import React from 'react';
import Header from './Header';
import Footer from './Footer';

/**
 * Layout component - wraps all pages with header and footer
 * Implements sticky header, navigation, and footer (Requirements 4.1, 4.2, 4.3, 4.4, 4.6, 8.6)
 */
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Header with logo, navigation, and search */}
      <Header />

      {/* Main content */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer with association info and links */}
      <Footer />
    </div>
  );
};

export default Layout;
